import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import Topbar from "../../components/Topbar/Topbar";
import "./Dashboard.css";
import CreateCampaign from "../CreateCampaign/CreateCampaign";
import { Route, Routes, useNavigate } from "react-router-dom";
import AllCampaign from "../../components/AllCampaign/AllCampaign";
import EditCampaign from "../../components/EditCampaign/EditCampaign";
import CampaignDetail from "../campaignDetail/CampaignDetail";
import SetSeriesPriority from "../../components/SetSeriesPriority/SetSeriesPriority";
import AddProducts from "../AddProducts/AddProducts";
import Login from "../Login/Login";
import AllRewardProducts from "../../components/AllRewardProducts/AllRewardProducts";
import EditProduct from "../../components/EditProduct/EditProduct";
const Dashboard = () => {
  const navigate = useNavigate();
  let pathname = window.location.pathname;

  useEffect(() => {
    const isAccessToken = localStorage.getItem("access_token");
    // console.log(isAccessToken)
    if (isAccessToken === null) {
      navigate("/admin/login");
    }
    // setaccessToken(isAccessToken)
  }, []);

  if (pathname === "/admin/login") {
    return (
      <div className="loginContainer">
        <Login />
      </div>
    );
  } else {
    return (
      <div>
        {/* <Topbar /> */}

        <div className="container">
          <Sidebar />
          <div className="others">
            {/* {pathname} */}
            {/* <Routes> */}
            {pathname === "/admin" || pathname === "/admin/all-campaign" ? (
              <AllCampaign />
            ) : null}
            {pathname === "/admin/create-campaign" ? <CreateCampaign /> : null}
            {pathname === "/admin/all-reward-products" ? (
              <AllRewardProducts />
            ) : null}
            {pathname === "/admin/edit-campaign" ? <EditCampaign /> : null}
            {pathname === "/admin/edit-product" ? <EditProduct /> : null}
            {pathname === "/admin/campaign-detail" ? <CampaignDetail /> : null}
            {pathname === "/admin/series-list" ? <SetSeriesPriority /> : null}
            {pathname === "/admin/add-products" ? <AddProducts /> : null}

            {/* <Route exact path = '/admin/create-campaign' element = {<CreateCampaign  />} /> */}
            {/* </Routes> */}

            {/* <CreateCampaign />  */}

            {/* <DynamicForm /> */}
          </div>
        </div>
      </div>
    );
  }
};

export default Dashboard;
